
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_fh8q7_5",
  "trigger": "awsui_trigger_14cnr_fh8q7_17",
  "dropdown": "awsui_dropdown_14cnr_fh8q7_20",
  "nowrap": "awsui_nowrap_14cnr_fh8q7_31",
  "open": "awsui_open_14cnr_fh8q7_34"
};
  